import { put, takeEvery } from 'redux-saga/effects'

function* tourStart(action) {
    try {
        if (!action.payload.stepId) {
            return;
        }

        yield put({
            type: 'CURRENT_USER_UPDATE_REQUESTED',
            payload: {
                userProps: {
                    tour_passed: action.payload.stepId.split(':')[0]
                }
            }
        });

        yield put({
            type: 'TOUR_START_SUCCEEDED',
            payload: {
                stepId: action.payload.stepId
            }
        });
    } catch (e) {
        yield put({
            type: 'TOUR_START_FAILED',
            payload: {
                message: e.message || e
            }
        });
    }
}

function* tourSkip(action) {
    try {
        yield put({
            type: 'CURRENT_USER_UPDATE_REQUESTED',
            payload: {
                userProps: {
                    tour_passed: action.payload.stepId.split(':')[0]
                }
            }
        });

        yield put({
            type: 'TOUR_SKIP_SUCCEEDED',
            payload: {
                stepId: action.payload.stepId
            }
        });
    } catch (e) {
        yield put({
            type: 'TOUR_SKIP_FAILED',
            payload: {
                message: e.message || e
            }
        });
    }
}

function* watchTourStart() {
    yield takeEvery('TOUR_START_REQUESTED', tourStart);
}

function* watchTourSkip() {
    yield takeEvery('TOUR_SKIP_REQUESTED', tourSkip);
}

export default [watchTourStart, watchTourSkip];
